import DAHasErrorModel from '../../../models/error/DAHasErrorModel';

const state = () => ({
    saveConfigurations: [],
    getConfigurations:  [],
    editConfigurations: [],
    hasErrorConfiguration: new DAHasErrorModel(),
})

export default state